module.exports = __webpack_public_path__ + "media/bootstrap-icons/bezier-458100b4.svg";